var render = function render(){var _vm=this,_c=_vm._self._c;return _c('outboxCon',{attrs:{"bg":_vm.bg}},[_c('div',{staticClass:"teacher-methods"},[_c('app-title',{attrs:{"main":_vm.main,"sub":_vm.sub}}),_c('methosScroll',{attrs:{"imgList":_vm.config.imgList,"navList":_vm.config.navList,"sectionHeight":_vm.config.sectionHeight,"boxHeight":_vm.config.boxHeight,"id":_vm.config.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }